module.exports = __webpack_public_path__ + "static/media/matnrrd_3-774w.1077d23f.png";